import { createSlice } from '@reduxjs/toolkit';

export interface dtcState {
  data: any[];
  allDTC: any[];
  allGroupedDTCData: any[];
  isLoading: boolean;
}

const initialState: dtcState = {
  data: [],
  allDTC: [],
  allGroupedDTCData: [],
  isLoading: true,
};

export const dtcSlice = createSlice({
  name: 'dtc',
  initialState,
  reducers: {
    getAll(state, { payload }) {
      return {
        ...state,
        data: payload,
        isLoading: false,
      };
    },
    setLoading(state, { payload }) {
      state.isLoading = payload;
    },

    getAllData(state, { payload }) {
      return {
        ...state,
        allDTC: payload,
        isLoading: false,
      };
    },
    getAllGroupedData(state, { payload }) {
      return {
        ...state,
        allGroupedDTCData: payload,
        isLoading: false,
      };
    },
  },
});

export const { getAll, setLoading, getAllData, getAllGroupedData } =
  dtcSlice.actions;
export default dtcSlice.reducer;
